import { render, staticRenderFns } from "./CreateAbondance.vue?vue&type=template&id=83b02a76&scoped=true&"
import script from "./CreateAbondance.vue?vue&type=script&lang=js&"
export * from "./CreateAbondance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b02a76",
  null
  
)

export default component.exports